'use strict';

var _regeneratorRuntime = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src3315055034/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _require = require('readable-web-to-node-stream'),
    ReadableWebToNodeStream = _require.ReadableWebToNodeStream;

var core = require('./core');

function fromStream(_x) {
  return _fromStream.apply(this, arguments);
}

function _fromStream() {
  _fromStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
    var readableWebToNodeStream, fileType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readableWebToNodeStream = new ReadableWebToNodeStream(stream);
            _context.next = 3;
            return core.fromStream(readableWebToNodeStream);

          case 3:
            fileType = _context.sent;
            _context.next = 6;
            return readableWebToNodeStream.close();

          case 6:
            return _context.abrupt("return", fileType);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fromStream.apply(this, arguments);
}

function fromBlob(_x2) {
  return _fromBlob.apply(this, arguments);
}
/**
Convert Blobs to ArrayBuffer.
@param {Blob} blob - Web API Blob.
@returns {Promise<ArrayBuffer>}
*/


function _fromBlob() {
  _fromBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blob) {
    var buffer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return blobToArrayBuffer(blob);

          case 2:
            buffer = _context2.sent;
            return _context2.abrupt("return", core.fromBuffer(Buffer.from(buffer)));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fromBlob.apply(this, arguments);
}

function blobToArrayBuffer(blob) {
  if (blob.arrayBuffer) {
    return blob.arrayBuffer();
  } // TODO: Remove when stop supporting older environments


  return new Promise(function (resolve, reject) {
    var fileReader = new FileReader();
    fileReader.addEventListener('loadend', function (event) {
      resolve(event.target.result);
    });
    fileReader.addEventListener('error', function (event) {
      reject(new Error(event.message));
    });
    fileReader.addEventListener('abort', function (event) {
      reject(new Error(event.type));
    });
    fileReader.readAsArrayBuffer(blob);
  });
}

Object.assign(module.exports, core, {
  fromStream: fromStream,
  fromBlob: fromBlob
});